import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ThemeProvider } from '@material-ui/core/styles';

import { Theme } from '../theme';
import { Icons } from '../icons/icons';
import { Unicons } from '../icons/unicons';
import { StyledTextField, StyledTextFieldIcon } from '../mui/mui-textfield';

// Material-UI Pickers
import { DateTimePicker, KeyboardDateTimePicker } from '@material-ui/pickers';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import moment from 'moment';
import {
  LocalizedUtils,
  createPickerTheme,
  getPickerLanguage,
  getPickerLocale,
  setPickerMomentLocale
} from './mui-pickers.utils';

// TextField DatePicker
const MuiTextField = ({ ...props }) => {
  return (
    <StyledTextField
      {...props}
      InputProps={{ endAdornment: (<Unicons.Calendar size="20" style={{ minHeight: '20px', minWidth: '20px' }} />) }}
    />
  );
};

// TextFieldIcon DatePicker
const MuiTextFieldIcon = ({ ...props }) => {
  return (
    <StyledTextFieldIcon
      {...props}
      InputProps={{ startAdornment: (<Icons.FilterList />), endAdornment: (<Unicons.Calendar size="20" style={{ minHeight: '20px', minWidth: '20px' }} />) }}
    />
  );
};

// Formats
// dd/mm/yyyy -> lu/09/2020
// DD/mm/yyyy -> 21/09/2020
// LL -> 21 de septiembre de 2020
// dddd LL -> viernes 21 de septiembre de 2020

const materialTheme = createPickerTheme({
  MuiPickersToolbar: {
    toolbar: {
      height: '70px',
      backgroundColor: Theme.colors.greyDark,
      '& h3': {
        fontFamily: 'Bryant Pro Bold',
        fontSize: Theme.typography.heading1,
        fontWeight: 'normal',
        letterSpacing: 'normal',
        whiteSpace: 'normal',
      },
      '& h4': {
        fontFamily: 'Bryant Pro Bold',
        fontSize: Theme.typography.heading4,
        fontWeight: 'normal',
        letterSpacing: 'normal',
        whiteSpace: 'normal',
      },
      '& h6': {
        fontFamily: 'Bryant Pro Regular',
        fontSize: Theme.typography.heading6,
        fontWeight: 'normal',
        letterSpacing: '0.0175em',
        whiteSpace: 'normal',
      },
    }
  },
  MuiPickerDTTabs: {
    tabs: {
      color: Theme.colors.greyDark,
      backgroundColor: Theme.colors.greyLight,
    }
  }
});

const MuiDateTimePicker = (props) => {
  const lang = getPickerLanguage();
  const locale = getPickerLocale(lang);

  useEffect(() => {
    setPickerMomentLocale(lang);
  }, [lang]);

  const {
    allowKeyboard,
    mask,
    isFilter,
    ...restProps
  } = props;

  // 
  return (
    <ThemeProvider theme={materialTheme}>
      <MuiPickersUtilsProvider utils={LocalizedUtils} locale={locale} moment={moment}>
        {!allowKeyboard ? (
          <DateTimePicker
            {...restProps}
            autoOk
            variant="inline"
            mask={mask ? mask : '__/__/____'}
            leftArrowIcon={<Icons.ArrowLeft />}
            rightArrowIcon={<Icons.ArrowRight />}
            dateRangeIcon={<Unicons.Calendar size="20" />}
            timeIcon={<Icons.Time />}
            TextFieldComponent={!isFilter ? MuiTextField : MuiTextFieldIcon}
          />
        ) : (
          <KeyboardDateTimePicker
            {...restProps}
            autoOk
            variant="inline"
            mask={mask ? mask : '__/__/____'}
            leftArrowIcon={<Icons.ArrowLeft />}
            rightArrowIcon={<Icons.ArrowRight />}
            dateRangeIcon={<Unicons.Calendar size="20" />}
            timeIcon={<Icons.Time />}
            TextFieldComponent={StyledTextField}
          />
        )}
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
};

MuiDateTimePicker.propTypes = {
  // Boolean to change DatePicker to KeyboardDatePicker.
  allowKeyboard: PropTypes.bool,
  // Mask to keyboard.
  mask: PropTypes.string,
  // Boolean to show filter icon in TextField.
  isFilter: PropTypes.bool
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

/* KeyboardDateTimePicker Styles */
export const StyledDateTimePicker = styled(MuiDateTimePicker)`
  .MuiIconButton-root {
    padding: 8px;
    right: -8px;
    color: ${(props) => props.theme.colors.greyDark};
  }
`;
